import React from 'react';
import { Button } from '../ui/button';

const WHATSAPP_LINK = 'https://wa.me/523312949249?text=Quiero%20mi%20menú%20digital%20para%20mi%20negocio';

const navigationLinks = [
  { id: 'nav-benefits', label: 'Beneficios', section: 'benefits' },
  { id: 'nav-pricing', label: 'Planes', section: 'pricing' },
  { id: 'nav-faq', label: 'FAQ', section: 'faq' },
];

export const NavLinks = ({ onNavigate, isMobile = false }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      if (onNavigate) onNavigate();
    }
  };

  const linkClass = isMobile
    ? 'block w-full text-left px-4 py-3 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors'
    : 'text-sm font-medium text-muted-foreground hover:text-foreground transition-colors';

  return (
    <>
      {navigationLinks.map((link) => (
        <button
          key={link.id}
          onClick={() => scrollToSection(link.section)}
          className={linkClass}
        >
          {link.label}
        </button>
      ))}
      {isMobile && (
        <Button
          className="w-full bg-gradient-to-r from-[hsl(var(--cta-orange))] to-[hsl(var(--cta-orange-hover))] text-white"
          onClick={() => {
            window.open(WHATSAPP_LINK, '_blank');
            if (onNavigate) onNavigate();
          }}
        >
          Comenzar ahora
        </Button>
      )}
    </>
  );
};

export const Logo = () => (
  <span className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Saira, sans-serif' }}>
    ZAPPIEN AI
  </span>
);
